module.exports = __webpack_public_path__ + "img/hdp3.5033fe6c.png";